import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import { TDeviceType } from '@cian/ui-kit';
import { parseCookies } from '@cian/utils/lib/shared/cookie';
import { createSelector } from 'reselect';

import { trackBannerEvent } from './tracking';
import {
  LISTING_TGB_TRACKING_LABELS,
  LISTING_TGB_SLIDER_TRACKING_LABELS,
} from '../../../ListingDesktop/containers/Adfox/constants';
import { selectListingOffers } from '../../selectors/listingOffers';
import { selectUserId } from '../../selectors/user';
import { sendTeaserEvent } from '../../services/teaser';
import { TThunkAction } from '../../types/redux';
import { isFlatSearch } from '../../utils/isFlatSearch';

interface ISoprEventData {
  bannerType?: 'tgb' | 'parallax' | 'tgb_slider';
  position?: number;
  isMap?: boolean;
}

export interface IBannerTrackingLabels {
  serp: ITrackingLabels | null;
  map: ITrackingLabels | null;
}

export interface ITrackingLabels {
  show: string;
  click: string;
}

const TRACKING_LABELS_MAP: { [key: string]: IBannerTrackingLabels } = {
  tgb: LISTING_TGB_TRACKING_LABELS,
  tgb_slider: LISTING_TGB_SLIDER_TRACKING_LABELS,
};

export const triggerAdsEvent =
  (
    isShow: boolean,
    deviceType: TDeviceType,
    data: IAdFoxBannerOnLoadData | null,
    soprEvent?: ISoprEventData,
  ): TThunkAction =>
  (dispatch, getState, context) => {
    const state = getState();
    const userId = selectUserId(state);

    const soprApi = context.config.get<string>('soprApi.browserUrl');

    const bannerId = !!data && data.bundleParams.bannerId;
    const shouldSendAdsEvent = isFlatSearch(state.results.jsonQuery);

    if (!soprApi || !bannerId || !shouldSendAdsEvent) {
      return;
    }

    sendTeaserEvent(soprApi, {
      user_id: userId,
      device_type: deviceType,
      cid: parseCookies(document.cookie)['_CIAN_GK'],
      pageType: 'Listing',
      items: [
        {
          action: isShow ? 'show' : 'click',
          bannerId,
          bannerPlace: 'offersSerp',
          timestamp: Date.now(),
          dl: window.location.href,
        },
      ],
    });

    if (soprEvent) {
      const offerIds = createSelector(selectListingOffers, offers => offers.map(of => of.id));
      const { bannerType, position, isMap } = soprEvent;

      const trackingLabels = bannerType ? TRACKING_LABELS_MAP[bannerType] : null;
      const pageLabels = isMap ? trackingLabels?.map : trackingLabels?.serp;
      const eventName = isShow ? pageLabels?.show : pageLabels?.click;

      if (bannerId && eventName) {
        trackBannerEvent({
          bannerId,
          name: eventName,
          position,
          jsonQuery: state.results.jsonQuery,
          isShortListing: isMap ? !!offerIds.length && offerIds.length < 5 : undefined,
        });
      }
    }
  };
